export default class CircleColor {
    public indexColor: number;
    public color: string;

    constructor(indexColor: number, color: string) {
        this.indexColor = indexColor;
        this.color = color;
    }
}
